import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

export const getBidStatusAPI = async (eventId, eventItemId, params = {}) => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}events/${eventId}/item/${eventItemId}/mybidstatus`,
    params: { ...params },
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default getBidStatusAPI;
